import { Company, CompanyType } from "src/app/generated/CrossPoint.RemoteXpac.Server";

export function emptyCompany(type: CompanyType = CompanyType.Dealer): Company {
    return {
        code: "",
        companyId: "",
        companyType: type,
        description: "",
        shardContainerId: "",
        parentCompanyId: null,
    };
}